// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"c9de12e4","164":"bf4b0e25","215":"60c61ee9"}[chunkId] + ".chunk.js";
};